export default "__VITE_ASSET__D5I4qNR3__"